import { Button, Col, Container, Label, Row } from 'reactstrap';
import NavbarComponent from '../Components/Header/Navbar';
import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as yup from 'yup';
import InputComponent from '../Components/Common/InputComponent';
import { useDispatch, useSelector } from 'react-redux';
import { updateLoginCred } from '../Store/commonStore/actions';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { APIClient } from '../helpers/ApiHeleps';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import { getTenantConfig } from '../Components/Common/Util';

const DashboardLogin = () => {
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const api = new APIClient();
    const dispatch = useDispatch();
    const userCredential = useSelector((state) => state.CommonStore.loginToken);

    const channel = new BroadcastChannel('my-channel');
    const location = useLocation();
    const tenantConfig = getTenantConfig(location?.pathname);

    useEffect(() => {
        if (userCredential?.apiKey && userCredential?.token) {
            // history.push('/dashboard');
            channel.postMessage({ action: 'login' });
        }
    }, [userCredential]);

    const loginAPIObj = {
        url: 'auth/login',
        method: 'POST',
        token: `Basic ${tenantConfig.REACT_APP_TRACK_AUTH_TOKEN}`,
        apiKey: `${tenantConfig.REACT_APP_TRACT_API_KEY}`,
        customEndPointUrl: process.env.REACT_APP_API_BASE_URL
    };

    const loginApiCall = async (reqBody) => {
        try {
            setLoading(true);
            const resp = await api.customApiCall(loginAPIObj, false, '', reqBody);
            if (resp?.data?.isSuccess) {
                let token = resp?.data?.data?.token;
                let apiKey = resp?.data?.data?.apiKey;
                token && apiKey && dispatch(updateLoginCred({ apiKey: apiKey, token: token }));
                setLoading(false);
            } else if (!resp?.data?.isSuccess) {
                toast.error('Invalid Username or Password');
                setLoading(false);
            }
        } catch (error) {
            toast.error('Something went wrong please check.');
            setLoading(false);
        }
    };

    return (
        <React.Fragment>
            <Container className="page-content" fluid>
                <div className="mb-5">
                    <NavbarComponent language={undefined} languagesList={undefined} changeLanguages={undefined} />
                </div>
                <div className="login-box border  border-success ">
                    <Row className="py-5 px-4">
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                            <h4 className="text-center text-primary fw-bold fs-24">LOGIN</h4>
                        </Col>
                        <Formik
                            initialValues={{ username: '', password: '' }}
                            validationSchema={yup.object({
                                username: yup.string().required('User Name Required.'),
                                password: yup.string().required('Password is required.')
                            })}
                            onSubmit={(values) => {
                                loginApiCall(values);
                            }}
                        >
                            {({ setFieldValue, values, errors, handleSubmit, touched, handleBlur }) => (
                                <>
                                    <Row>
                                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="d-flex my-2">
                                            <Label className="col-form-label ">
                                                Username
                                                <span className="text-danger">*</span>
                                            </Label>
                                        </Col>
                                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="d-flex mb-4">
                                            <InputComponent
                                                type="text"
                                                id="username"
                                                name="username"
                                                className="input-default "
                                                placeholder={'Enter User Name'}
                                                value={values?.username}
                                                invalid={errors?.username && touched.username}
                                                onBlur={handleBlur}
                                                disabled={false}
                                                onChange={(e) => {
                                                    setFieldValue('username', e.target.value);
                                                }}
                                            />
                                        </Col>
                                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="d-flex my-2">
                                            <Label className="col-form-label">
                                                Password
                                                <span className="text-danger">*</span>
                                            </Label>
                                        </Col>
                                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="d-flex mb-4">
                                            <InputComponent
                                                type="password"
                                                id="password"
                                                name="password"
                                                className="input-default "
                                                placeholder={'Enter Password'}
                                                value={values?.password}
                                                invalid={errors?.password && touched.password}
                                                onBlur={handleBlur}
                                                disabled={false}
                                                onChange={(e) => {
                                                    setFieldValue('password', e.target.value);
                                                }}
                                            />
                                        </Col>
                                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="d-flex mt-2">
                                            <Button
                                                color="success"
                                                onClick={handleSubmit}
                                                type="submit"
                                                className="my-2 w-100"
                                                disabled={loading}
                                            >
                                                {loading ? 'Proceeding...' : 'Submit'}
                                            </Button>
                                        </Col>
                                    </Row>
                                </>
                            )}
                        </Formik>
                    </Row>
                </div>
            </Container>
        </React.Fragment>
    );
};
export default DashboardLogin;
